import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-ext";
var WorktopDrawing = /** @class */ (function (_super) {
    tslib_1.__extends(WorktopDrawing, _super);
    function WorktopDrawing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(WorktopDrawing.prototype, "worktopStyles", {
        get: function () {
            return {
                opacity: this.$ui.drawing.ready ? 1 : 0,
                width: this.$ui.drawing.worktopLength + "%",
                height: this.$ui.drawing.worktopWidth + "%",
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "worktopClasses", {
        get: function () {
            return {
                "raised-edge": this.$state.edgeProfileCode == "Raised"
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "sinkSafetyAreaStyles", {
        get: function () {
            return {
                height: this.$ui.drawing.safetyAreaWidth + "%",
                width: this.$ui.drawing.safetyAreaLength + "%",
                left: this.$ui.drawing.safetyAreaLeft + "%"
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "sinkDistanceLeftValue", {
        get: function () {
            return this.$state.sinkDistanceMeasuredTo == "edge"
                ? this.$ui.sinkDistanceLeft
                : this.$ui.sinkDistanceLeftCenter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "cssSinkDistanceLeft", {
        get: function () {
            return this.$state.sinkDistanceMeasuredTo == "edge"
                ? this.$ui.drawing.sinkDistanceLeft
                : this.$ui.drawing.sinkDistanceLeftCenter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "sinkDistanceRightValue", {
        get: function () {
            return this.$state.sinkDistanceMeasuredTo == "edge"
                ? this.$ui.sinkDistanceRight
                : this.$ui.sinkDistanceRightCenter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "cssSinkDistanceRight", {
        get: function () {
            return this.$state.sinkDistanceMeasuredTo == "edge"
                ? this.$ui.drawing.sinkDistanceRight
                : this.$ui.drawing.sinkDistanceRightCenter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "hobcutoutDistanceLeftValue", {
        get: function () {
            return this.$state.hobcutoutDistanceMeasuredTo == "edge"
                ? this.$ui.hobcutoutDistanceLeft
                : this.$ui.hobcutoutDistanceLeftCenter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "cssHobcutoutDistanceLeft", {
        get: function () {
            return this.$state.hobcutoutDistanceMeasuredTo == "edge"
                ? this.$ui.drawing.hobcutoutDistanceLeft
                : this.$ui.drawing.hobcutoutDistanceLeftCenter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "hobcutoutDistanceRightValue", {
        get: function () {
            return this.$state.hobcutoutDistanceMeasuredTo == "edge"
                ? this.$ui.hobcutoutDistanceRight
                : this.$ui.hobcutoutDistanceRightCenter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "cssHobcutoutDistanceRight", {
        get: function () {
            return this.$state.hobcutoutDistanceMeasuredTo == "edge"
                ? this.$ui.drawing.hobcutoutDistanceRight
                : this.$ui.drawing.hobcutoutDistanceRightCenter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "sinkContainerStyles", {
        get: function () {
            return {
                width: this.$ui.drawing.sinkLength + "%",
                height: this.$ui.drawing.sinkWidth + "%",
                left: this.$ui.drawing.sinkDistanceLeft + "%",
                top: this.$ui.drawing.sinkDistanceBack + "%"
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "sinkContainerClasses", {
        get: function () {
            var classes = [];
            if (this.$ui.sink.sinkCount) {
                classes.push('sinks-' + this.$ui.sink.sinkCount.toString().replace(".", "-"));
            }
            classes.push("w-" + this.$ui.worktopWidth.toString());
            classes.push(this.$ui.sink.code.toLowerCase());
            classes.push(this.$state.sinkHandedness.toLowerCase());
            return classes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "hobcutoutContainerStyles", {
        get: function () {
            return {
                width: this.$ui.drawing.hobcutoutLength + "%",
                height: this.$ui.drawing.hobcutoutWidth + "%",
                left: this.$ui.drawing.hobcutoutDistanceLeft + "%",
                bottom: this.$ui.drawing.hobcutoutDistanceFront + "%"
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "sinkMeasurementsStyles", {
        get: function () {
            return {
                left: this.$ui.drawing.sinkDistanceLeft + "%",
                width: this.$ui.drawing.sinkLength + "%",
            };
        },
        enumerable: true,
        configurable: true
    });
    WorktopDrawing.prototype.getSinkHoleClasses = function (hole) {
        return "hole-" + hole.toLowerCase();
    };
    Object.defineProperty(WorktopDrawing.prototype, "hobcutoutMeasurementsStyles", {
        get: function () {
            return {
                left: this.$ui.drawing.hobcutoutDistanceLeft + "%",
                width: this.$ui.drawing.hobcutoutLength + "%",
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "sinkVisible", {
        get: function () {
            return this.$ui.sink.drawing && this.$state.sinkDistanceX && this.$ui.sink.length > 0 && !this.$ui.sinkHasPlacementError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "sinkDimensionsXVisible", {
        get: function () {
            return this.sinkVisible && this.$state.sinkDistanceX && (this.editableFields && this.editableFields.indexOf("sinkDistanceLeft") != -1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "sinkDimensionsYVisible", {
        get: function () {
            return this.sinkVisible && this.editableFields && this.editableFields.indexOf("sinkDistanceFront") != -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "hobcutoutVisible", {
        get: function () {
            return this.$state.hobcutout == '1'
                && this.$ui.hobcutoutLength > 0
                && this.$ui.hobcutoutWidth > 0
                && this.$ui.hobcutoutDistanceLeft > 0
                && this.$ui.hobcutoutDistanceFront > 0
                && !this.$ui.hobcutoutHasPlacementError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "hobcutoutDimensionsXVisible", {
        get: function () {
            return this.hobcutoutVisible && (this.editableFields && this.editableFields.indexOf("hobcutoutLength") != -1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "hobcutoutDimensionsYVisible", {
        get: function () {
            return this.hobcutoutVisible && (this.editableFields && this.editableFields.indexOf("hobcutoutDistanceFront") != -1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "summaryDimensionsVisible", {
        get: function () {
            return this.editableFields && this.editableFields.indexOf("summary") != -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "sinkStyles", {
        get: function () {
            return {
                "background-image": "url('" + this.$ui.drawing.sinkDrawing + "')"
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorktopDrawing.prototype, "hobcutoutStyles", {
        get: function () {
            return {
                "background-image": "url('" + this.$ui.drawing.hobcutoutDrawing + "')"
            };
        },
        enumerable: true,
        configurable: true
    });
    WorktopDrawing.prototype.dimensionClasses = function (fieldName) {
        var classes = [];
        if (!this.editableFields || this.editableFields.indexOf(fieldName) == -1)
            classes.push("disabled");
        if (this.$ui.focusedFieldName == fieldName)
            classes.push("focused");
        return classes;
    };
    tslib_1.__decorate([
        Prop({ type: Array }),
        tslib_1.__metadata("design:type", Array)
    ], WorktopDrawing.prototype, "editableFields", void 0);
    WorktopDrawing = tslib_1.__decorate([
        Component
    ], WorktopDrawing);
    return WorktopDrawing;
}(Vue));
export default WorktopDrawing;
